<!-- eslint-disable vuejs-accessibility/heading-has-content -->
<template>
  <div class="tabs-snippet">
    <hr class="tabs-snippet__divider">

    <div class="tabs-snippet__header">
      <template
        v-for="(block, index) of blocks"
        :key="`${block.title}-${index}`"
      >
        <div class="tabs-snippet__tab-header-wrapper">
          <h2>
            <btn
              class="tabs-snippet__tab-header"
              :class="{ 'active': index === activeTab }"
              :label="block.title"
              modifiers="text center"
              type="button"
              @click="activeTab = index"
            />
          </h2>
        </div>
      </template>
    </div>

    <div class="tabs-snippet__content">
      <div
        v-for="(block, index) of blocks"
        v-show="index === activeTab"
        :key="`${block.title}-${index}`"
        class="main-product__tab-content-wrapper"
      >
        <div v-if="block?.body && block?.isRteContent">
          <rte-content
            :class="block?.classes || ''"
            :content="block.body || ''"
          />
        </div>

        <div
          v-else-if="block?.body"
          v-html="block?.body"
        />

        <div v-if="block.productFitNotes || block.productFitGraphic">
          <fit-notes
            :product-fit-notes="block?.productFitNotes || null"
            :product-fit-graphic="block?.productFitGraphic || null"
          />

          <btn
            type="button"
            modifiers="text inline"
            class-label="text-body-2xs-underline"
            :label="$string('product.accordions.view_size_guide')"
            @click="$emit('open-size-guide')"
          />
        </div>

        <shopping-gives-modal
          v-if="block.enableCustomSGModal"
          :content="block.enableCustomSGModal"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Tabs snippet (tabs-snippet)
 * -----------------------------------------------------------------------------
 * Snippet for tabs pdp.
 *
 */
// eslint-disable-next-line import/named
import { defineAsyncComponent } from 'vue'

import ShoppingGivesModal from '~async/shopping-gives-modal/shopping-gives-modal'
import Btn from '~global/btn/btn'
import FitNotes from '~async/fit-notes/fit-notes'

export default {
  name: 'TabsSnippet',

  components: {
    Btn,
    FitNotes,
    RteContent: defineAsyncComponent({
      loader: () => import(
        /* webpackChunkName: 'component.rte-content' */
        '~async/rte-content/rte-content'
      ),
    }),
    ShoppingGivesModal,
  },

  props: {
    blocks: {
      type: [Boolean, Array],
      default: () => [],
    },
  },

  emits: {
    'open-size-guide': () => true,
    'open-custom-sg': () => true,
  },

  data() {
    return {
      activeTab: 0,
    }
  },

  mounted() {
    this.$nextTick().then(() => {
      const sgLink = document.querySelector('a[title="#vbgb"]')
      if (sgLink) {
        sgLink.addEventListener('click', (event) => {
          event.preventDefault()

          this.$emit('open-custom-sg')
        })
      }
    })
  },
}
</script>

<style lang="scss">
@import './tabs-snippet';
</style>
